import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const tiles = [
  { to: '/astro/natal',      iconSrc: '/icons/natal.png',            titleKey: 'astro.natal_title',      descKey: 'astro.natal_desc' },
  { to: '/astro/horoscope',  iconSrc: '/icons/astro-horoscope.png',  titleKey: 'astro.horoscope_title',  descKey: 'astro.horoscope_desc' },
  { to: '/astro/weekly',     iconSrc: '/icons/astro-weekly.png',     titleKey: 'astro.weekly_title',     descKey: 'astro.weekly_desc' },
  { to: '/astro/transits',   iconSrc: '/icons/astro-transits.png',   titleKey: 'astro.transits_title',   descKey: 'astro.transits_desc' },
  { to: '/astro/retrograde', iconSrc: '/icons/astro-retrograde.png', titleKey: 'astro.retrograde_title', descKey: 'astro.retrograde_desc' },
] as const

export function AstroIndexRoute() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-4 pb-6">
      <header className="flex flex-col gap-1">
        <h1 className="font-serif text-2xl text-sage-800">{t('astro.section_title')}</h1>
        <p className="text-sm text-sage-600">{t('astro.index_intro')}</p>
      </header>
      <ul className="flex flex-col gap-3">
        {tiles.map((tile) => (
          <li key={tile.to}>
            <Link
              to={tile.to}
              className="flex items-center gap-3 rounded-2xl bg-white/70 p-4 ring-1 ring-sage-200/60 transition hover:bg-white active:scale-[0.99]"
            >
              <img
                src={tile.iconSrc}
                alt=""
                aria-hidden="true"
                className="h-10 w-10 shrink-0 select-none"
                draggable={false}
              />
              <div className="min-w-0 flex-1">
                <h3 className="font-serif text-lg text-sage-800">{t(tile.titleKey as never)}</h3>
                <p className="text-sm text-sage-600">{t(tile.descKey as never)}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
